@if (currentImage(); as currentImage) {
  <div class="product-gallery">
    @if ((price().data?.discountPercent ?? 0) > 0) {
      <div class="product-gallery-discount">-{{ price().data?.discountPercent }}%</div>
    }

    <cx-media [media]="currentImage.zoom" (click)="openMediasModal(TAB_GALLERY.PHOTO)" role="none" (mediaError)="onImageError($event)" />

    @if (!imgError) {
      <product-thumb-images [product]="product" [currentImage]="currentImage" (setContainer)="onSetContainer($event)" />
    }

    @if (product.medias?.videos?.length) {
      <button type="button" class="btn btn-outline-primary m-t-20 w-100" (click)="openMediasModal(TAB_GALLERY.VIDEO)">
        <span class="material-symbols-outlined m-r-4">play_circle</span>
        {{ 'product.media.videos' | translate }}
      </button>
    }
  </div>
}
